module.exports = __webpack_public_path__ + "static/assets/1534f418f7c534b22a888ad39510f5b9.png";